import * as Preact from "preact"
import Navigation from "@frog/source/models/Navigation.js"

import TestListScreen from "@frog/source/views/dev/screens/TestListScreen.view.js"
import TestDetailsScreen from "@frog/source/views/dev/screens/TestDetailsScreen.view.js"
import TestWidget from "@frog/source/views/dev/widgets/TestWidget.view.js"
import BuildWidget from "@frog/source/views/dev/widgets/BuildWidget.view.js"

import "@frog/source/views/dev/Dev.view.less"

const screens = {
    "TestListScreen": TestListScreen,
    "TestDetailsScreen": TestDetailsScreen,
}

export default class Dev {
    render() {
        return (
            <div class="Dev">
                <div class="Widgets">
                    <BuildWidget/>
                    <TestWidget/>
                </div>
                {this.screen}
            </div>
        )
    }
    get screen() {
        if(Navigation.state.devscreen != undefined) {
            if(screens[Navigation.state.devscreen] != undefined) {
                const Screen = screens[Navigation.state.devscreen]
                return <Screen/>
            }
        }
    }
}
